(function (jedeye) {
    "use strict";

    jedeye(window.jQuery, window, document);
}(function ($, window, document) {
        "use strict";

        moment.locale($('html').attr('lang')); // Set momentJS locale

        // Global Utils
        window.JedeyeUtils = {

            scrollToGroupSegments: function ($elem, yoffset) {
                $('html, body').animate({
                        scrollTop: $('#groupSegments').offset().top  //$('#container > header').height()
                    }, {duration: 500}
                );
            },

            scrollTo: function (id) {
                $('html, body').animate({
                        scrollTop: $('#' + id).offset().top  //$('#container > header').height()
                    }, {duration: 500}
                );
            },

            showModalPopup: function (title, message) {
                title = title || '';
                message = message || '';
                $('#modalPopup #modalPopupLabel').html(title);
                $('#modalPopup .modal-body').html(message);
                $('#modalPopup').modal('show');
            },

            swapGroupRate: function (baseGroupID, groupRate) {
                var $ukmsContainer = $('#groupContainer_' + baseGroupID).find('.u-kms-rate:eq(0)');
                var $lkmsContainer = $('#groupContainer_' + baseGroupID).find('.l-kms-rate:eq(0)');
                var $sendProposalBtn = $('.send-proposal-btn', '#groupContainer_' + baseGroupID);
                if (groupRate == 'u-kms-rate') {
                    $sendProposalBtn.attr('data-target', $sendProposalBtn.data('target-origin') + '_' + 'ukms');
                    $ukmsContainer.addClass('bounceIn animated').show();
                    $lkmsContainer.hide();
                } else {
                    $sendProposalBtn.attr('data-target', $sendProposalBtn.data('target-origin') + '_' + 'lkms');
                    $ukmsContainer.hide();
                    $lkmsContainer.addClass('bounceIn animated').show();
                }
            },
            // /* Deals with ajax added extras to the summary mini slider */
            refreshExtraToSummarySlider: function (extraID) {
                $('.same-height-3').responsiveEqualHeightGrid();
                var targetID = '#extra-' + extraID + ' > .data';
                var price = null;

                if ($(targetID).data('extra-enabled') == true) {
                    if ($('#extra-slider-' + extraID).length > 0) { // Update item price
                        price = $(targetID).data('extra-price');
                        $('#extra-slider-' + extraID).find('.extra-price').html(price);
                    } else { // Create item
                        var title = $(targetID).data('extra-quant') + ' x ' + $(targetID).data('extra-title');
                        var subtitle = $(targetID).data('extra-subtitle');
                        price = $(targetID).data('extra-price');
                        var content = '<div id="extra-slider-' + extraID + '" class="item"><div class="extra-title">' + title + '</div><div class="extra-subtitle">' + subtitle + '</div><div class="extra-price">' + price + '</div></div>';
                    }

                    // Sidebar Items
                    if ($('#extra-sb-item-' + extraID).length > 0) { // Update item price
                        price = $(targetID).data('extra-price');
                        var quantity = $(targetID).data('extra-quant');
                        $('#extra-sb-item-' + extraID).find('.price-value').html(price);
                        $('#extra-sb-item-' + extraID).find('.quant').html(quantity);
                        $('#extra-sb-item-' + extraID).removeClass('hidden');
                    }

                } else {
                    // Sidebar Items
                    targetID = $('#extra-sb-item-' + extraID);
                    targetID.addClass('hidden');
                }
            },

            refreshPackageSummary: function (packageID) {
                var targetID = '#packageContainer-' + packageID;
                if ($('.package-item.active').length > 0)
                    $('.package-group').addClass('has-package-selected');
                else
                    $('.package-group').removeClass('has-package-selected');

                $('#extra-summary-blocks .package-row').addClass('disabled');

                if ($('#extra-sb-item-' + packageID).length > 0 && $(targetID).hasClass('active')) { // Update item price
                    var price = $(targetID).data('package-price');
                    //var quantity = $(targetID).data('extra-quant');
                    $('#extra-sb-item-' + packageID).find('.price-value').html(price);
                    //$('#package-sb-item-'+packageID).find('.quant').html(quantity);
                    $('#extra-sb-item-' + packageID).removeClass('disabled');

                    // Remove all individual extras which are binded to this package
                    if ($(targetID).data('package-extras') != '') {
                        var extras = $(targetID).data('package-extras').split(",");
                        $.each(extras, function () {
                            $('#extra-sb-item-' + this.toString()).addClass('disabled');
                        });
                    }
                }
            },

            setupSidebar: function () {

                if ($('.sidebar-inner').length == 0) {
                    return;
                }

                // Fixes sidebar max-with when it turns absolute positioned
                $('.sidebar-inner').css('max-width', $('.reservation-sidebar-pane').width());

                // Side bar
                setTimeout(function () {
                    //var topElemHeight = $(window).width() <= 980 ? 290 + $('.info-panel').outerHeight() : 1055 + $('.info-panel').outerHeight();
                    var topElemHeight = $(window).width() <= 980 ? 290 + $('.reservation-sidebar-pane').offset().top : $('.info-panel').offset().top + $('.info-panel').outerHeight();
                    //var bottomElemHeight = $('.booking-summary-bar').outerHeight() + $('.value-proposition-bar').outerHeight() + $('.our-offers').outerHeight() + $('#layout-footer').outerHeight();
                    var bottomElemHeight = $('.booking-summary-bar').length > 0 ? $(document).height() - $('.booking-summary-bar').offset().top : $(document).height() - $('.value-proposition-bar').offset().top;
                    $('.sidebar-inner').affix({
                        offset: {
                            top: function () {
                                return topElemHeight
                            },
                            bottom: bottomElemHeight // footer top border adjustment
                        }
                    });
                }, 300);
            },

            goToPaymentPane: function (e) {
                var $elem = $('#reservationPaymentMethodsHeader > div');
                $('.payment-section').removeClass('pulse animated');
                $('html, body').animate({
                        scrollTop: $elem.offset().top - 25
                    }, {
                        duration: 500,
                        done: function () {
                            $('.payment-section').addClass('pulse animated');
                        }
                    }
                );

                return false;
            },

            validateOptionalData: function (event, element) {
                if (window.paymentElem != null && $(window.paymentElem).data("validation-passed") == "true")
                    return true;
                if ($('#driverDocId').val() == "" || $('#driverLicenseId').val() == "") {
                    event.stopPropagation();
                    window.paymentElem = element;
                    $('#optionalDataCheckModal').modal('show');
                    return false;
                }

                return true;
            },

            paymentProceed: function () {
                if (window.paymentElem != null) {
                    $(window.paymentElem).data("validation-passed", "true");
                    $(window.paymentElem).trigger("click"); // Executes payment action
                    $('#optionalDataCheckModal').modal('hide');
                } else {
                    $('#optionalDataCheckModal').modal('hide');
                }

                return true;
            },

            focusMissingOptionalData: function () {
                var $elem = $('#optionalDataPane');
                $('html, body').animate({
                        scrollTop: $elem.offset().top - 25
                    }, {
                        duration: 500,
                        done: function () {
                            $('input[type="text"]:not(.datepicker-forward)', $elem.parent()).each(function () {
                                if (this.value === '') {
                                    $(this).addClass('pulse animated');
                                    this.focus();
                                    return false;
                                }
                            });
                        }
                    }
                );
                return false;
            }
        };


        $(window).on('ajaxUpdateComplete', function (event, context, data) {

            /**
             * Trigger custom alerts.
             */
            if (data.hasOwnProperty('alert')) {
                $(document).trigger("jedeye.showModalPopup", [data.alert.message, data.alert.title, data.alert.subtitle, data.alert.iconClass]);
            }

            // Manages modal triggering or dismissing from the server side responses
            if (data.hasOwnProperty('triggerModal')) {
                $(data.triggerModal).fitModalToScreen().modal('show');
            } else {
                if (data.hasOwnProperty('dismissModal')) {
                    $(data.dismissModal).modal('hide');
                }
            }
        });

        $(document).router({
            // Homepage
            dom_home: function () {
                $("#campaignsSlideshow").owlCarousel({
                    items: 1,
                    itemsDesktop: false,
                    itemsDesktopSmall: false,
                    itemsTablet: false,
                    itemsMobile: false,
                    autoHeight: true,
                    autoPlay: 5000
                });

                $("#backgroundSlideshow").owlCarousel({
                    items: 1,
                    itemsDesktop: false,
                    itemsDesktopSmall: false,
                    itemsTablet: false,
                    itemsMobile: false,
                    touchDrag: false,
                    mouseDrag: false,
                    pagination: false,
                    autoPlay: 5000,
                    transitionStyle: 'fadeUp'
                });

                $("#fleetCarsCarousel").owlCarousel({
                    pagination: false,
                    lazyLoad: true,
                    navigation: true,
                    navigationText: false,
                    autoHeight: true,
                    itemsDesktop: [1940, 4],
                    itemsDesktopSmall: [1400, 3],
                    itemsTablet: [960, 2],
                    itemsTabletSmall: [616, 1]
                });

            },

            dom_stations: function () {
                $("body").on("change", ".stations-dropdown", function (e) {
                    var selectedItemID = $(this).val();
                    $.oc.stripeLoadIndicator.show();
                    $.request('locationsPickerCustom::onStationSelect', {
                        data: {id: selectedItemID},
                        success: function (data) {
                            this.success(data);
                        }
                    });
                });
            },

            dom_booking_form: function () {
                // Check if datepicker or timepicker fields are filled on page load
                $('.date-field > input, .time-field > input').each(
                    function () {
                        if ($(this).val() != "") {
                            $(this).parent().addClass('has-value');
                        }
                    }
                );
            },

            dom_book_now: function () {
                // Scrollspy for Book Now Bar
                $('#bookNowAnchor').on('scrollSpy:enter', function () {
                    $('#bookNowBtn').removeClass('fixed');
                });

                $('#bookNowAnchor').on('scrollSpy:exit', function () {
                    if ($('#bookNowBtn').offset().top < $(document).scrollTop()) {
                        return;
                    }
                    $('#bookNowBtn').addClass('fixed');
                });

                $('#bookNowAnchor').scrollSpy();

                $('#bookNowBtn').addClass('fixed'); // Fix bar at page load (it will unfix itself if it is visible in viewport)

                // Placeholder space to avoid scrollspy issues when transiting from static to fixed positioning
                $('#bookNowBtn').wrap('<section class="container-fluid" style="height:' + $('#bookNowBtn').outerHeight(true) + 'px;width:100%;padding:0;margin:0;"></section>');

                $('#bookNowBtn').click(function (e) {
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: $('#bookNowAnchor').offset().top - 5 //$('#container > header').height()
                    }, {
                        duration: 900, complete: function () {
                            $('#bookNowBtn').parent().slideUp(function () {
                                $('#bookNowFormContainer').slideDown(function () {
                                    $('html, body').animate({
                                        scrollTop: $('#bookNowFormContainer').offset().top - 5 //$('#container > header').height()
                                    }, 500);
                                });
                            });
                        }
                    });
                });

                $('.close-icon').click(function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    $('#bookNowBtn').parent().slideUp();
                });
            },

            dom_booking: function () {

                /* Booking Summary Top Bar */
                $('#summaryChart').easyPieChart({
                    animate: {duration: 3000, enabled: true},
                    easing: 'easeOutBounce',
                    lineWidth: 7,
                    trackColor: '#CCCCCC',
                    scaleColor: false,
                    size: 55,
                    lineCap: 'butt',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    }
                });

                $('#finishChart').easyPieChart({
                    animate: {duration: 3000, enabled: true},
                    easing: 'easeOutBounce',
                    lineWidth: 15,
                    trackColor: '#CCCCCC',
                    scaleColor: false,
                    size: 145,
                    lineCap: 'butt',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    }
                });

                $("#bookingSummarySlide").owlCarousel({
                    items: 2,
                    itemsDesktop: false,
                    itemsDesktopSmall: [1060, 1],
                    itemsTablet: [950, 2],
                    itemsMobile: [700, 1],
                    pagination: false,
                    navigation: true,
                    navigationText: ['&#59477;', '&#59483;'],
                    rewindNav: false,
                });

                $("#extraDetailsMiniSlide").owlCarousel({
                    items: 2,
                    itemsDesktop: false,
                    itemsDesktopSmall: false,
                    itemsTablet: false,
                    itemsMobile: false,
                    mouseDrag: false
                });

                $("#sideExtraSummaryMiniSlide").owlCarousel({
                    items: 1,
                    itemsDesktop: false,
                    itemsDesktopSmall: false,
                    itemsTablet: [990, 2],
                    itemsMobile: [600, 1],
                    mouseDrag: true,
                    pagination: true,
                    navigation: false,
                    navigationText: ['&#59477;', '&#59483;'],
                    rewindNav: false
                });

                $("#finishPageExtrasSlide").owlCarousel({
                    items: 2,
                    itemsDesktop: false,
                    itemsDesktopSmall: false,
                    itemsTablet: [990, 2],
                    itemsMobile: [600, 1],
                    mouseDrag: true,
                    pagination: true,
                    navigation: false,
                    navigationText: ['&#59477;', '&#59483;'],
                    rewindNav: false
                });

                // Check if datepicker or timepicker fields are filled on page load
                $('.date-field > input, .time-field > input').each(
                    function () {
                        if ($(this).val() != "") {
                            $(this).parent().addClass('has-value');
                        }
                    }
                );

            },

            dom_booking_step2: function () {
                $('.car-item-included .details-toggle').click(function (e) {
                    e.preventDefault();
                    $(this).parents('.action-buttons:first').next('.included-text').slideToggle(400);
                    $(this).toggleClass('active');
                    if ($(this).hasClass('active')) {
                        $(this).find('.action-text').html($(this).data('hide-text'));
                    } else {
                        $(this).find('.action-text').html($(this).data('show-text'));
                    }
                });
            },

            dom_booking_step3: function () {
                /* Extras Quantity Changer */
                $('html').click(function () {
                    $('.extra-row').removeClass('selection-active');
                    $('.extra-quant-change-notice').html('');
                });

                $('.car-selection-extras-quant .extra-quant-link').on("click", function (e) {
                    e.preventDefault();
                    var $parent = $(this).parents('.extra-row:first');
                    $('.extra-row').each(function () {
                        $(this).removeClass('selection-active');
                    });
                    $parent.addClass('selection-active');
                    $parent.find('button').attr("disabled", false);
                    var $target = $parent.find('.quantity-input > input[type="text"]');
                    $target.val($target.parents('.car-selection-extras-quant:first').find('.quant').html()).focus().select();
                });

                $('.quantity-input, .extra-quant-link').on("click", function (event) {
                    event.stopPropagation();
                });

                $('.quantity-input button').on("click", function () {
                    var $elem = $(this);
                    var $parent = $(this).parents('.extra-row:first');
                    var $input = $parent.find('.quantity-input > input[type="text"]');
                    $elem.attr("disabled", true);
                    $input.attr("disabled", true);
                    $parent.addClass('loading');
                    $('#totalPriceBlock').addClass('loading');
                    var extraID = $parent.data("id");
                    var extraQuant = $input.val();
                    $('form').request('onExtraQuantitySet', {
                        data: {extraid: extraID, extraquant: extraQuant},
                        success: function (data) {
                            this.success(data);
                            window.JedeyeUtils.refreshExtraToSummarySlider(extraID);
                            $('.extra-row').each(function () {
                                $(this).removeClass('selection-active');
                            });
                            $parent.removeClass('loading');
                            $('#totalPriceBlock').removeClass('loading');
                            $elem.attr("disabled", false);
                            $input.attr("disabled", false);
                        }
                    });
                });

                $('#plusExtrasBtn').on("click", function () {
                    var $elem = $(this);
                    $elem.addClass('loading');
                    setTimeout(function () {

                        var $section = $('#carExtras').find('.extras-section').not(':visible').first();
                        $section.slideDown(500, function () {
                            window.JedeyeUtils.scrollToElem($section);
                        });
                        if ($('#carExtras').find('.extras-section').not(':visible').length == 0)
                            $elem.hide();

                        $elem.removeClass('loading');

                    }, 1000);

                });

                // Makes extra blocks clickable
                $('body').on('click', '.carExtras article', function (event) {

                    if (!$(event.target).closest('.add-btn').length &&
                        !$(event.target).is('.add-btn') &&
                        !$(event.target).is('button')
                    ) {

                        if ($('.content .quantity-picker', this).hasClass('disabled')) {
                            return false;
                        }

                        var extraQuant = $('.content ', this).data("extra-quant");
                        if (extraQuant == "0") {
                            $(this).find('.add-btn').trigger("click");
                        } else {
                            // Remove all quantities for this extra
                            $('#totalPriceBlock').addClass('loading');
                            var extraID = $(this).attr('id').substring(6);
                            extraQuant = 0;
                            $('form').data('request-loading', '.spinner-overlay').request('onExtraQuantitySet', {
                                data: {extraid: extraID, extraquant: extraQuant},
                                success: function (data) {
                                    this.success(data);
                                    $('.extra-row').each(function () {
                                        $(this).removeClass('selection-active');
                                    });
                                    window.JedeyeUtils.refreshExtraToSummarySlider(extraID);
                                    $('#totalPriceBlock').removeClass('loading');
                                }
                            });
                        }
                    }
                });
            },

            dom_booking_step_4: function () {
                $("#driver_birth_date").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": 18,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                $(".select-date-picker").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": $(this).data('min'),
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });

                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });
            },

            dom_sidebar: function () {
                var mobileBookingBarDistance = $('#totalPriceBlock').length > 0 ? $('#totalPriceBlock').offset().top : 0,
                    $window = $(window);

                $window.scroll(function () {
                    if ($window.width() < 992 && mobileBookingBarDistance > 0 && $window.scrollTop() >= mobileBookingBarDistance) {
                        if (!$('.mobile-summary-stick').is(':visible')) {
                            $('.mobile-summary-stick').slideDown(500);
                        }
                    } else {
                        $('.mobile-summary-stick').slideUp(500);
                    }
                });

                $window.resize(function () {
                    // Fixes sidebar max-with when it turns absolute positioned
                    window.JedeyeUtils.setupSidebar();
                });

                window.JedeyeUtils.setupSidebar();
            },

            dom_modal_fit: function () {
                $('.modal-fit-window-btn').on("click", function () {
                    var target = $(this).data('target');
                    var height = $(window).height() - 255; //value corresponding to the modal heading + footer
                    var targetFrame = $(target).find('.modal-frame').length > 0 ? '.modal-frame' : '.modal-body';
                    $(target + ' ' + targetFrame).css({"max-height": height, "overflow-y": "auto"});
                    $(target).modal('show');

                    return false;
                });
            },

            dom_same_height_grid: function () {
                $('.same-height, .same-height-2, .same-height-3').responsiveEqualHeightGrid();
            },

            dom_tooltips: function () {
                /* Tooltips */
                $('[data-toggle="tooltip"]').tooltip();
            },

            // Shared code
            common: function () {

                function showModalPopup(message, title, subtitle, iconClass) {
                    title = title || '';
                    subtitle = subtitle || '';
                    message = message || '';
                    iconClass = iconClass || '';
                    var $modal = $('#appModal:first');
                    $('.m-title', $modal).html(title);
                    $('.m-subtitle', $modal).html(subtitle);
                    $('.m-message', $modal).html(message);
                    $('#appModalIcon', $modal).removeClass().addClass('icon').addClass(iconClass);
                    $modal.modal('show');
                }

                $(document).on('jedeye.showModalPopup', function (event, message, title, subtitle, iconClass) {
                    showModalPopup(message, title, subtitle, iconClass);
                });

                // code put inside the common property will be executed on all page loads
                function centerModal() {
                    $(this).css('display', 'block');
                    var $dialog = $(this).find(".modal-dialog"),
                        offset = ($(window).height() - $dialog.height()) / 2,
                        bottomMargin = parseInt($dialog.css('marginBottom'), 10);

                    // Make sure you don't hide the top part of the modal w/ a negative margin if it's longer than the screen height, and keep the margin equal to the bottom margin of the modal
                    if (offset < bottomMargin) offset = bottomMargin;
                    $dialog.css("margin-top", offset);
                }

                $(document).on('show.bs.modal', '.modal', centerModal);
                $(window).on("resize", function () {
                    $('.modal:visible').each(centerModal);
                });

                $('#layout-header .lang-select').each(function () {
                    var $self = $(this);
                    $self.ddslick({
                        width: 100,
                        background: '#FFFFFF',
                        onSelected: function (data) {
                            if (!$self.hasClass('initialized')) {
                                $self.addClass('initialized');
                                return false;
                            }
                            $.oc.stripeLoadIndicator.show();
                            $.request('localePicker::onSwitchLocale', {
                                data: {locale: data.selectedData.value},
                                success: function (data) {
                                    this.success(data);
                                }
                            });
                        }
                    });
                });

                $(".custom-select").select2();
                $(".custom-select-no-sb").select2({
                    minimumResultsForSearch: -1
                });

                $(".pushy li").has("ul").find('> a').click(function (e) {
                    e.stopImmediatePropagation();
                    $(this).parent().find('ul').slideToggle(500);
                });
            }
        }, true);
    }
));